module.exports = __webpack_public_path__ + "img/kz.e3cd3d05.svg";